import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';

const AddPurchaseReturns = () => {
    const navigate = useNavigate();

    // State to hold form input values
    const [formData, setFormData] = useState({
        pack_unit: '',
        pack_qty: '',
        unit: '',
        quantity: '',
        rate: '',
        amount: '',
        discount: '',
        taxcode: '',
        taxrate: '',
        taxable: '',
        taxamount: '',
        cess_rate: '',
        cess_amount: '',
        mrp: '',
        net_rate: '',
        remarks: '',
        item_barcode: '',
        posting_gl: '',
        pi_vno: '',
        pi_ref_no: '',
        pi_ref_date: '',
        pi_vdate: '',
        bd_batch_no: '',
        bd_mfg_date: '',
        bd_exp_date: '',
        bd_sale_rate: '',
        item_balance: '',
        barcode: '',
        line_level_barcode: '',
        lgst: '',
        cgst: '',
        sgst: '',
        hsn_code: '',
        brand: ''
    });

    // Handle form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();

        // Prepare data for POST request
        const data = {
            ...formData,
            pi_ref_date: new Date(formData.pi_ref_date).toISOString(),
            pi_vdate: new Date(formData.pi_vdate).toISOString(),
            bd_mfg_date: new Date(formData.bd_mfg_date).toISOString(),
            bd_exp_date: new Date(formData.bd_exp_date).toISOString(),
        };

        // POST request to add purchase return
        fetch(`${BASE_URL}purchasereturns`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    // Redirect to the list after successful addition
                    navigate('/PurchaseReturnsList');
                }
            })
            .catch((error) => {
                console.error('Error adding purchase return:', error);
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Add Purchase Return</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Add Purchase Return Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Enter Purchase Return Details</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="pack_unit">Pack Unit</label>
                                                <input
                                                    type="text"
                                                    id="pack_unit"
                                                    name="pack_unit"
                                                    className="form-control"
                                                    value={formData.pack_unit}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="pack_qty">Pack Quantity</label>
                                                <input
                                                    type="number"
                                                    id="pack_qty"
                                                    name="pack_qty"
                                                    className="form-control"
                                                    value={formData.pack_qty}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="unit">Unit</label>
                                                <input
                                                    type="text"
                                                    id="unit"
                                                    name="unit"
                                                    className="form-control"
                                                    value={formData.unit}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="quantity">Quantity</label>
                                                <input
                                                    type="number"
                                                    id="quantity"
                                                    name="quantity"
                                                    className="form-control"
                                                    value={formData.quantity}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="rate">Rate</label>
                                                <input
                                                    type="number"
                                                    id="rate"
                                                    name="rate"
                                                    className="form-control"
                                                    value={formData.rate}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="amount">Amount</label>
                                                <input
                                                    type="number"
                                                    id="amount"
                                                    name="amount"
                                                    className="form-control"
                                                    value={formData.amount}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="discount">Discount</label>
                                                <input
                                                    type="number"
                                                    id="discount"
                                                    name="discount"
                                                    className="form-control"
                                                    value={formData.discount}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="taxcode">Tax Code</label>
                                                <input
                                                    type="text"
                                                    id="taxcode"
                                                    name="taxcode"
                                                    className="form-control"
                                                    value={formData.taxcode}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="taxrate">Tax Rate</label>
                                                <input
                                                    type="number"
                                                    id="taxrate"
                                                    name="taxrate"
                                                    className="form-control"
                                                    value={formData.taxrate}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="taxable">Taxable</label>
                                                <input
                                                    type="number"
                                                    id="taxable"
                                                    name="taxable"
                                                    className="form-control"
                                                    value={formData.taxable}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="taxamount">Tax Amount</label>
                                                <input
                                                    type="number"
                                                    id="taxamount"
                                                    name="taxamount"
                                                    className="form-control"
                                                    value={formData.taxamount}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="cess_rate">Cess Rate</label>
                                                <input
                                                    type="number"
                                                    id="cess_rate"
                                                    name="cess_rate"
                                                    className="form-control"
                                                    value={formData.cess_rate}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="cess_amount">Cess Amount</label>
                                                <input
                                                    type="number"
                                                    id="cess_amount"
                                                    name="cess_amount"
                                                    className="form-control"
                                                    value={formData.cess_amount}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="mrp">MRP</label>
                                                <input
                                                    type="number"
                                                    id="mrp"
                                                    name="mrp"
                                                    className="form-control"
                                                    value={formData.mrp}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="net_rate">Net Rate</label>
                                                <input
                                                    type="number"
                                                    id="net_rate"
                                                    name="net_rate"
                                                    className="form-control"
                                                    value={formData.net_rate}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="remarks">Remarks</label>
                                                <textarea
                                                    id="remarks"
                                                    name="remarks"
                                                    className="form-control"
                                                    value={formData.remarks}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="item_barcode">Item Barcode</label>
                                                <input
                                                    type="text"
                                                    id="item_barcode"
                                                    name="item_barcode"
                                                    className="form-control"
                                                    value={formData.item_barcode}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="posting_gl">Posting GL</label>
                                                <input
                                                    type="text"
                                                    id="posting_gl"
                                                    name="posting_gl"
                                                    className="form-control"
                                                    value={formData.posting_gl}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="pi_vno">PI Vendor No</label>
                                                <input
                                                    type="text"
                                                    id="pi_vno"
                                                    name="pi_vno"
                                                    className="form-control"
                                                    value={formData.pi_vno}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="pi_ref_no">PI Ref No</label>
                                                <input
                                                    type="text"
                                                    id="pi_ref_no"
                                                    name="pi_ref_no"
                                                    className="form-control"
                                                    value={formData.pi_ref_no}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="pi_ref_date">PI Ref Date</label>
                                                <input
                                                    type="date"
                                                    id="pi_ref_date"
                                                    name="pi_ref_date"
                                                    className="form-control"
                                                    value={formData.pi_ref_date}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-success">Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AddPurchaseReturns;
